// components/common/ErrorAlert.jsx
import React from "react";
import { AlertCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/Alert";
import { Button } from "@/components/ui/Button";

const ErrorAlert = ({ message, onRetry }) => {
  return (
    <Alert variant="destructive" className="mt-4">
      <AlertCircle className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>{message || "Ha ocurrido un error"}</span>
        {onRetry && (
          <Button
            variant="outline"
            size="sm"
            onClick={onRetry}
            className="ml-4"
          >
            Reintentar
          </Button>
        )}
      </AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
